import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const SelectedItemLabel = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex: 1;
    color: var(--Foreground-Neutral, #14171f);

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export const AddOptionButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  box-sizing: border-box;
  margin: 4px 0px;

  cursor: pointer;
`

export const AddOptionIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 16px;
  height: 16px;

  svg {
    font-size: 16px;
    fill: var(--Foreground-Primary, #4d4be7);
  }
`

export const AddOptionLabel = styled.div`
  color: var(--Foreground-Primary, #4d4be7);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const InputContainer = styled.div`
  padding: 12px 6px;
  border-top: 1px solid var(--Border-Neutral, #dfe2ea);

  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: end;

  div:first-child {
    flex: 1;
    height: 38px;
  }
`

export const AddButtonContainer = styled.div<{ disabled?: boolean }>`
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  height: 36px;
  width: 36px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 6px;
  background: ${({ disabled }) =>
    disabled ? 'var(--Background-Neutral, #DFE2EA)' : 'var(--Background-Primary, #5A58F2)'};

  svg {
    width: 14px;
    height: 14px;

    path {
      fill: ${({ disabled }) => (disabled ? 'var(--Foreground-Neutral-faded, #4D5874)' : 'white')};
    }
  }
`
